import { render, staticRenderFns } from "./testTask.vue?vue&type=template&id=8d056018&scoped=true"
import script from "./testTask.vue?vue&type=script&lang=js"
export * from "./testTask.vue?vue&type=script&lang=js"
import style0 from "./testTask.vue?vue&type=style&index=0&id=8d056018&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d056018",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d056018')) {
      api.createRecord('8d056018', component.options)
    } else {
      api.reload('8d056018', component.options)
    }
    module.hot.accept("./testTask.vue?vue&type=template&id=8d056018&scoped=true", function () {
      api.rerender('8d056018', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/product-details/firmware/taskList/testTask.vue"
export default component.exports